import {Component, inject, OnInit} from '@angular/core';
import {AuthService} from '@services/auth.service';

/**
 * Страница, которую Keycloak открывает во iframe при frontchannel logout.
 * Роут находится вне защищённого layout, и рендерится всегда: сессии к этому
 * моменту уже нет, гард её бы не пропустил.
 *
 * Ограничение, о котором важно знать: документ внутри iframe чужого сайта работает
 * в отдельном партиционированном хранилище (Chrome 115+, Firefox, Safari). Поэтому
 * logoffLocal() здесь чистит пустую копию localStorage, а broadcastLogout() не доходит
 * до вкладок приложения — их сигнал приходит из вкладки-инициатора (AuthService.
 * completeLogout). Страница оставлена как страховка для браузеров без партиционирования
 * и как тот адрес, который прописан клиенту в Keycloak.
 */
@Component({
    selector: 'app-frontchannel-logout',
    template: ``,
    standalone: true,
})
export class FrontchannelLogoutComponent implements OnInit {

    private readonly authService = inject(AuthService);

    ngOnInit(): void {
        // Там, где партиционирования нет, это единственный путь: чистим токены во всех
        // вкладках (localStorage общий) и сообщаем живым вкладкам, что нужно перезагрузиться.
        this.authService.logoffLocal();
        this.authService.broadcastLogout();
    }
}
